import React from "react";
import CriticalIllnessTabImage from "../../Assets/Images/critical-illness-tab-mobile-image.png";
import CheckIcon from "../../Assets/Images/check-white-icon.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import translation hook

const CoveredFull = () => {
  const translations = useTranslation(); // Get translations dynamically

  return (
    <>
      <div className="flex flex-col lg:mt-[5rem] mt-[2rem]">
        <div className="animate__animated animate__fadeInRight lg:hidden block -mr-4 mb-10">
          <img
            src={CriticalIllnessTabImage}
            width={"100%"}
            className="object-cover w-full"
            alt="not found"
          />
        </div>
        <div className="mb-4 animate__animated animate__fadeIn lg:max-w-[450px] md:px-0 px-4 cover100-content">
          <p className="md:text-[16px] text-[14px] mb-3 extra-para-vs">
            {translations.coveredFull.description}
          </p>
          <div className="flex mt-6">
            <div className="md:w-2/3 w-3/5">
              <ul className="md:text-[16px] text-[14px]">
                {Object.entries(translations.coveredFull.diseases)
                  .slice(0, 6) // First column
                  .map(([key, value]) => (
                    <li key={key} className="flex items-center mb-4 extra-para-vs">
                      <div className="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] bg-[#53BCC8] rounded-full covered-col-circle">
                        <img
                          src={CheckIcon}
                          alt="Check Icon"
                          className="w-[10px] h-[10px]"
                        />
                      </div>
                      <span className="ml-1.5">{value}</span>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="md:w-1/3 w-2/5">
              <ul className="md:text-[16px] text-[14px]">
                {Object.entries(translations.coveredFull.diseases)
                  .slice(6) // Second column
                  .map(([key, value]) => (
                    <li key={key} className="flex items-center mb-4 extra-para-vs">
                      <div className="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] bg-[#53BCC8] rounded-full covered-col-circle">
                        <img
                          src={CheckIcon}
                          alt="Check Icon"
                          className="w-[10px] h-[10px]"
                        />
                      </div>
                      <span className="ml-1.5">{value}</span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoveredFull;
